module.exports = __webpack_public_path__ + "static/img/2.7ce54202.png";